export default "__VITE_ASSET__DTYnE0sZ__"